import React, { useMemo } from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { useTranslation } from 'react-i18next';

import { PreLoader } from './PreLoader';

const Wrapper = () => {
  return useMemo(() => <PreLoader />, []);
};

export const Files = () => {
  const { t } = useTranslation();

  return (
    <>
      <DocumentHead title={t('Files')} />
      <PageTemplate main={<Wrapper />} />
    </>
  );
};
